export default __webpack_public_path__ + "static/media/woman2.036a1aa8.gif";